export const CATEGORY_EXAMPLES = {
  requirements_definition_operations: {
    title: "要件定義",
    category: "プロジェクトの背景と目的の理解",
    content: `営業部門および業務管理担当者へのヒアリングを実施し、
受発注業務がExcel管理により属人化していること、
入力ミスが月20件以上発生していることを課題として特定した。

現行業務フロー（As-Is）を可視化し、
入力プロセスの標準化および入力チェック機能の導入による
ミス削減を目的としたTo-Be像を整理した。

関係部署と認識合わせを行い、
要件定義の前提条件を確定した。`,
  },

  basic_design_operations: {
    title: "基本設計",
    category: "システムアーキテクチャの設計",
    content: `受発注管理システムにおける主要機能の設計を担当。

営業部門および業務担当者へのヒアリングを実施し、
受注登録・在庫連携・請求処理に関する業務要件を整理した。

現行業務フローをもとに機能ごとの処理内容や画面遷移を設計し、
業務効率化を目的とした機能構成を検討した。

関係部署との認識合わせや機能優先度の調整を行い、
開発スコープの策定および設計書作成に携わった。`,
  },

  detail_design_operations: {
    title: "詳細設計",
    category: "モジュール設計",
    content: `受発注管理システムにおける各機能の詳細設計を担当。

基本設計書をもとに処理フロー、入力チェック、
エラーハンドリングおよびデータ連携仕様を整理し、
モジュール単位での設計を実施した。

画面機能とバックエンド処理の責務を明確化するとともに、
外部システムとの連携インターフェース仕様を定義した。

また、設計レビューを通じて要件との整合性を確認し、
実装フェーズへ引き継ぐための設計書を作成した。`,
  },

  program_operations: {
    title: "製造/構築",
    category: "コード実装",
    content: `受発注管理システムにおける各機能のコード実装を担当。

詳細設計書をもとに、受注登録・在庫連携・請求処理に関する
フロントエンドおよびバックエンドの実装を行った。

入力チェック、エラーハンドリング、データ登録・更新処理を実装し、
業務要件に沿った機能となるよう動作確認を実施した。

また、コードレビューへの対応や単体テストの作成を行い、
品質を確保しながら実装作業を進めた。`,
  },

  test_operations: {
    title: "テスト",
    category: "テスト計画の策定",
    content: `受発注管理システムのテスト工程において、
テスト計画の策定およびテスト方針の検討を担当。

システム要件および設計書をもとに、
テスト対象範囲や実施スケジュールを整理し、
単体テスト・結合テスト・総合テストの実施方針を策定した。

また、想定される業務シナリオを整理し、
テスト観点やテストケースの作成を実施。

関係部署との調整を行いながらテスト体制を構築し、
品質確保に向けたテスト計画の推進に携わった。`,
  },

  maintenance_operations: {
    title: "運用/保守",
    category: "システム監視",
    content: `受発注管理システムの運用保守業務において、
システム監視および障害一次対応を担当。

監視ツールを利用してサーバーやアプリケーションの稼働状況を確認し、
異常検知時にはログ調査や影響範囲の確認を実施した。

また、定期的な監視結果の報告やアラート内容の分析を行い、
障害の未然防止およびシステムの安定稼働に努めた。

関係部署や開発チームと連携しながら、
インシデント対応および運用改善活動に携わった。`,
  },
};
